export interface GeneticMaterial {
  id: string;
  geneticMaterialId: number;
  name?: string;
  geneticMaterialTypeId: number;
  geneticMaterialTypeName?: string;
  geneticMaterialOriginalId: number;
  geneticMaterialOriginName?: string;
  speciesId: number;
  speciesName?: string;
  isCommercialMaterial: boolean;
  code?: string;
  resourceTypeId: number;
  resourceId: number;
  trayTypeId: number;
  trayTypeName?: string;
}

export class GeneticMaterialProperties {
  static readonly geneticMaterialId = 'geneticMaterialId';
}